"use strict";

exports.__esModule = true;
var _LinkButton = require("./LinkButton");
Object.keys(_LinkButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LinkButton[key]) return;
  exports[key] = _LinkButton[key];
});